<syslink-grid
  #grid
  [canView]="canView"
  [canSearch]="canSearch"
  [canRefresh]="canRefresh"
  [canAdd]="canAdd"
  [canSort]="canSort"
  [canUpdate]="canUpdate"
  [canDelete]="canDelete"
  [canFilter]="canFilter"
  [canExport]="canExport"
  [canDblClck]="canDblClck"
  [gridName]="storageKey"
  [service]="stockMoveIncomingLinesService"
  [columns]="columns"
  [filter]="filter"
  [storageKey]="storageKey"
  [select]="select"
  [expand]="expand"
></syslink-grid>
